import { format, parseISO } from "date-fns";
import { CalendarDays } from "lucide-react";
import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

export const DateField = ({ label, value, onChange, minDate, testid }) => {
  const [open, setOpen] = useState(false);
  const date = parseISO(value);
  return (
    <div className="field">
      <span className="field-label">{label}</span>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className="field-input flex items-center justify-between text-left" data-testid={testid}>
            <span className="truncate">{format(date, "d MMM yyyy")}</span>
            <CalendarDays className="h-4 w-4 text-brand" strokeWidth={1.5} />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start" {...(window.self !== window.top ? { side: "bottom", avoidCollisions: false } : {})}>
          <Calendar
            mode="single"
            selected={date}
            defaultMonth={date}
            disabled={{ before: minDate }}
            onSelect={(d) => {
              if (d) {
                onChange(format(d, "yyyy-MM-dd"));
                setOpen(false);
              }
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
